import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [accept, setAccept] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!accept) { toast.error("You must acknowledge the risk disclaimer"); return; }
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("ACCOUNT CREATED");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#050505] text-white p-6">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
        <div className="micro-label mb-3">/ register</div>
        <h2 className="font-heading text-3xl mb-8">New Operator</h2>

        <label className="micro-label">Name</label>
        <input
          data-testid="register-name"
          value={name} onChange={e=>setName(e.target.value)}
          className="w-full mt-1 mb-4 px-3 py-2 bg-[#0f0f0f] border border-[#222] focus:border-[#444] outline-none font-mono-data text-sm"
        />
        <label className="micro-label">Email</label>
        <input
          data-testid="register-email"
          type="email" required
          value={email} onChange={e=>setEmail(e.target.value)}
          className="w-full mt-1 mb-4 px-3 py-2 bg-[#0f0f0f] border border-[#222] focus:border-[#444] outline-none font-mono-data text-sm"
        />
        <label className="micro-label">Password</label>
        <input
          data-testid="register-password"
          type="password" required minLength={6}
          value={password} onChange={e=>setPassword(e.target.value)}
          className="w-full mt-1 mb-4 px-3 py-2 bg-[#0f0f0f] border border-[#222] focus:border-[#444] outline-none font-mono-data text-sm"
        />
        <label className="flex items-start gap-2 mb-6 cursor-pointer">
          <input
            type="checkbox"
            checked={accept}
            onChange={e=>setAccept(e.target.checked)}
            data-testid="register-accept"
            className="mt-0.5 accent-[#00e676]"
          />
          <span className="text-[10px] font-mono-data text-[#8a8a8e] leading-relaxed">
            I acknowledge this app is for informational and educational purposes only,
            is <strong className="text-white">NOT investment advice</strong>, and options trading
            carries substantial risk of loss. I agree to the{" "}
            <Link to="/disclaimer" className="underline text-white" target="_blank">Disclaimer</Link>
            {" "}and{" "}
            <Link to="/terms" className="underline text-white" target="_blank">Terms</Link>.
          </span>
        </label>
        <button
          data-testid="register-submit"
          disabled={loading || !accept}
          className="w-full py-3 bg-white text-black hover:bg-[#00e676] transition-colors text-sm font-medium tracking-widest uppercase disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "..." : "Create Account"}
        </button>
        <div className="mt-6 text-xs text-[#8a8a8e]">
          Have account? <Link to="/login" className="text-white underline" data-testid="link-login">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
